<div class="d-flex justify-content-between">
  <div>
    <rask-header size="4" noPadding>{{ "trädslagsdata - bestånd före avverkning" | uppercase }}</rask-header>
  </div>
  <div>
    <rask-forkalkyl-arboreal></rask-forkalkyl-arboreal>
  </div>
</div>
<div class="d-flex">
  <rask-textmultiline
    label="nettoareal"
    class="ps-0"
    value="{{atgard.nettoareal ?? 0 | number: '1.2-2': 'sv'}} ha">
  </rask-textmultiline>

  <rask-textmultiline
    id="uttagM3FHa"
    label="uttag m3f/ha"
    value="{{ uttagM3f ?? 0 }} m3f">
  </rask-textmultiline>

  <rask-textmultiline
    label="total volym"
    value="{{ totalVolym ?? 0 }} m3f">
  </rask-textmultiline>
</div>
<div>
  <rask-span [ngClass]="isAnyImported && model?.importKalla ? 'visible' : 'invisible'"
    class="text-uppercase importlabel-color ps-0">
    Trädslagsdata från {{model.importKalla}}
  </rask-span>
</div>
<div class="mt-4">
  <rask-hot-doc
    [hotDoc]="hotDoc">
  </rask-hot-doc>
</div>

<div class="d-flex mt-2">
  <div>
    <rask-add-tradslag-button
      [readonly]="readonly"
      [selectedTradslag]="selectedTradslag"
    (tradslagAdded)="onTradslagAdded($event)"></rask-add-tradslag-button>
  </div>
</div>

<div class="row mt-2">
  <div class="col">
    <div class="d-flex">
      <rask-button color="primary" [disabled]="!showCalculate() || readonly" (click)="calculateDirektutbyte()"
      class="px-0 my-0">Beräkna</rask-button>
      <rask-virkeskop-validation-icon-popover
        class="px-2"
        entityType="tradslag"
        [entityGuid]="atgard.guid">
      </rask-virkeskop-validation-icon-popover>
    </div>
  </div>
</div>


<div class="row mt-2">
  <div class="col">
    <rask-label size="5" class="px-0" aid="utbyte-senastberaknad">Senast beräknad: {{getBeraknadTid()}}</rask-label>
  </div>
</div>

@if ((messages$ | async).length > 0) {
  <div class="row mt-1 message-panel-layout">
    <rask-message-panel
      [numberOfItemsToDisplay]="3"
      [maxNumOfRows]="2"
      [items]="messages$">
    </rask-message-panel>
  </div>
}

<rask-tradslag-utbyte
  [utbyte]="$safeNavigationMigration(model?.utbyte)"
  [getProduktgruppVolym]="getProduktgruppVolym" [showInfo]="false">
</rask-tradslag-utbyte>